module.exports = __webpack_public_path__ + "static/media/player-link.ca52ef69.svg";